import React from 'react';
import { Box, useTheme } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import ViewSnippetComponent from '../components/snippets/SnippetViewer';

function ViewSnippet() {
  const { id } = useParams();
  const navigate = useNavigate();
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';
  
  const handleBack = () => {
    navigate('/snippets');
  };

  return (
     <Box sx={{
              width: '100%',
              minHeight: '100vh',
              backgroundColor: isDark ? '#0F172A' : theme.palette.background.default,
               p: 1.5
            }}>

      <ViewSnippetComponent 
        snippetId={id} 
        onBack={handleBack}
      />
    </Box>
  );
}

export default ViewSnippet;
